/** Doc ids under `participant/{uid}/economy/{docId}`. */
export const EconomyDocId = {
    COINS: "coins",
} as const;

export type EconomyDocId = (typeof EconomyDocId)[keyof typeof EconomyDocId];

/** `participant/{uid}/economy/coins` — private; not used for public ranking. */
export type EconomyCoins = {
    balance: number;
    updatedAt?: Date;
};

/** Both economy docs as loaded for the admin participant action. */
export type ParticipantEconomy = {
    coins: EconomyCoins | null;
};

export const emptyEconomyCoins = (): EconomyCoins => ({
    balance: 0,
});
